import { action, computed, observable } from 'mobx'
import { ModalViewModel } from '@/infra/ModalViewModel'

export interface RemoveItemData {
  id: string
  displayName: string
}

export interface RemoveBusinessDialogViewModelOptions {
  onConfirm: (id: string) => void
}

export class RemoveBusinessDialogViewModel {
  readonly modal = new ModalViewModel()

  @observable accessor _data: RemoveItemData | null = null

  constructor(
    private readonly _options: RemoveBusinessDialogViewModelOptions,
  ) {}

  @computed
  get businessName(): string {
    return this._data?.displayName || 'this business'
  }

  @action.bound
  showDialog(data: RemoveItemData) {
    this._data = data
    this.modal.show()
  }

  @action.bound
  closeDialog() {
    this.modal.close()
    this._data = null
  }

  @action.bound
  confirm() {
    if (this._data) {
      this._options.onConfirm(this._data.id)
    }
    this.closeDialog()
  }
}
